import React, { Component } from 'react';
import classNames from 'classnames/bind';
import axios from 'axios';

import {
  Button,
  Tooltip,
  I18n,
  Status,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export class RouterBuyRequests extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    axios.get('/api/profile/homeinternet/wifirouterbuytickets/')
      .then(({ data }) => this.setState({
        tickets: data.wiFiRouterBuyTicketsListInfo,
      }))
      .catch((error) => error);
  }

  showPopup = (ticket) => {
    const { ShowBuyRouterCard } = window.QA.Beeline.Pages.EquipmentPage.Index;
    ShowBuyRouterCard({ TicketNumber: ticket });
  }

  render() {
    const { tickets } = this.state;

    if (!tickets) return null;

    return tickets.map((ticket) => (
      <Status
        key={ticket.ticketNumber}
        className={['attention', cx('component')]}
        emoji="statusFail"
      >
        <I18n
          path="internet.routerBuyRequest.message"
          vars={{
            model: `${ticket.vendor} ${ticket.model}`,
            price: ticket.price,
          }}
        />

        {ticket.discount > 0 && (
          <Tooltip>
            <I18n
              path="internet.routerBuyRequest.discount"
              vars={{ sum: ticket.discount }}
            />
          </Tooltip>
        )}

        <div className={cx('button')}>
          <Button
            onClick={() => this.showPopup(ticket.ticketNumber)}
          >
            <I18n path="internet.routerBuyRequest.buy" />
          </Button>
        </div>
      </Status>
    ));
  }
}
